import React from 'react';
import GlobalResilienceMap from "./components/global-resilience-map/GlobalResilienceMap";
import GlobalResilienceIndex from "./components/global-resilience-index/GlobalResilienceIndex";
import CountryScorecard from "./components/country-scorecard/CountryScorecard";
import Compare from "./components/compare/Compare";
import './App.scss';

const App = () => {
  return (
    <div className="App">
      <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
        <header style={{ marginBottom: '40px', borderBottom: '2px solid #405363', paddingBottom: '20px' }}>
          <h1 style={{ color: '#405363', marginBottom: '10px' }}>
            Henley & Partners - Global Investment Risk & Resilience Index
          </h1>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Development Preview - All embeddable components shown below
          </p>
        </header>

        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ color: '#405363', marginBottom: '20px', fontSize: '24px' }}>
            1. Global Resilience Map
          </h2>
          <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '20px', backgroundColor: '#f9f9f9' }}>
            <GlobalResilienceMap />
          </div>
          <details style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Embed Code</summary>
            <pre style={{ background: '#f4f4f4', padding: '10px', borderRadius: '4px', marginTop: '10px' }}>
              {`<div data-global-resilience-map></div>`}
            </pre>
          </details>
        </section>

        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ color: '#405363', marginBottom: '20px', fontSize: '24px' }}>
            2. Global Resilience Index (Rankings Table)
          </h2>
          <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '20px', backgroundColor: '#f9f9f9' }}>
            <GlobalResilienceIndex />
          </div>
          <details style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Embed Code</summary>
            <pre style={{ background: '#f4f4f4', padding: '10px', borderRadius: '4px', marginTop: '10px' }}>
              {`<div data-global-resilience-index></div>`}
            </pre>
          </details>
        </section>

        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ color: '#405363', marginBottom: '20px', fontSize: '24px' }}>
            3. Country Scorecards
          </h2>
          <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '20px', backgroundColor: '#f9f9f9' }}>
            <CountryScorecard />
          </div>
          <details style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Embed Code</summary>
            <pre style={{ background: '#f4f4f4', padding: '10px', borderRadius: '4px', marginTop: '10px' }}>
              {`<div data-resilience-country-scoreboards></div>`}
            </pre>
          </details>
        </section>

        <section style={{ marginBottom: '60px' }}>
          <h2 style={{ color: '#405363', marginBottom: '20px', fontSize: '24px' }}>
            4. Compare Tool
          </h2>
          <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '20px', backgroundColor: '#f9f9f9' }}>
            <Compare baseUrl="" />
          </div>
          <details style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
            <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Embed Code</summary>
            <pre style={{ background: '#f4f4f4', padding: '10px', borderRadius: '4px', marginTop: '10px' }}>
              {`<div data-resilience-compare data-base-url="/scorecard"></div>`}
            </pre>
          </details>
        </section>

        <footer style={{ marginTop: '60px', paddingTop: '20px', borderTop: '1px solid #ddd', fontSize: '12px', color: '#999' }}>
          <p>
            <strong>Note:</strong> This preview page only appears in development mode when no embed divs are detected.
            In production, components are embedded via data attributes.
          </p>
        </footer>
      </div>
    </div>
  );
}

export default App;